module.exports = __webpack_public_path__ + "media/images/indigo/google-playstore-074bb8c417b0edb88cc51eedd0682438.svg";